"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackService = exports.EMPTY_FILE_ERROR_MESSAGE = void 0;
const node_1 = require("./node");
const constants_1 = require("../constants");
const file_1 = require("./file");
const types_1 = require("../types");
const stream_converter_1 = require("../util/stream-converter");
const crypto_1 = require("@akord/crypto");
const platform_1 = require("../util/platform");
const logger_1 = require("../logger");
const bad_request_1 = require("../errors/bad-request");
exports.EMPTY_FILE_ERROR_MESSAGE = "Cannot upload an empty file";
class StackService extends node_1.NodeService {
    constructor() {
        super(...arguments);
        this.fileService = new file_1.FileService(this.wallet, this.api);
        this.objectType = types_1.nodeType.STACK;
        this.NodeType = types_1.Stack;
        this.stackCreateDefaultOptions = Object.assign(Object.assign({}, this.defaultCreateOptions), { overrideFileName: true });
    }
    /**
     * @param  {string} vaultId
     * @param  {FileSource} file file source: web File object, file path, buffer or stream
     * @param  {StackCreateOptions} [options] parent id, progress hook, cancel hook, etc.
     * @returns Promise with new stack id & corresponding transaction id
     */
    create(vaultId, file, options = this.stackCreateDefaultOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const service = new StackService(this.wallet, this.api);
            yield service.setVaultContext(vaultId);
            service.setActionRef(constants_1.actionRefs.STACK_CREATE);
            service.setFunction(constants_1.functions.NODE_CREATE);
            const optionsFromVault = {
                storage: service.vault.cloud ? types_1.StorageType.S3 : types_1.StorageType.ARWEAVE
            };
            const createOptions = Object.assign(Object.assign(Object.assign({}, this.stackCreateDefaultOptions), optionsFromVault), options);
            const fileService = new file_1.FileService(this.wallet, this.api, service);
            fileService.contentType = this.fileService.contentType;
            const fileLike = yield (0, file_1.createFileLike)(file, Object.assign(Object.assign({}, options), { name: createOptions.overrideFileName ? options.name : undefined }));
            if (fileLike.size === 0) {
                throw new bad_request_1.BadRequest(exports.EMPTY_FILE_ERROR_MESSAGE);
            }
            const stackName = options.name || fileLike.name;
            service.setAkordTags((service.isPublic ? [stackName] : []).concat(createOptions.tags));
            const fileUploadResult = yield fileService.create(fileLike, createOptions);
            const version = yield fileService.newVersion(fileLike, fileUploadResult);
            const state = {
                name: yield service.processWriteString(stackName),
                versions: [version],
                tags: createOptions.tags || []
            };
            const { nodeId, transactionId, object } = yield service.nodeCreate(state, { parentId: createOptions.parentId }, options.arweaveTags);
            return { stackId: nodeId, transactionId, object, uri: object.uri };
        });
    }
    /**
     * @param  {string} vaultId
     * @param  {string} fileTxId arweave file transaction id reference
     * @param  {NodeCreateOptions} [options] parent id, etc.
     * @returns Promise with new stack id & corresponding transaction id
     */
    import(vaultId, fileTxId, options = this.defaultCreateOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const service = new StackService(this.wallet, this.api);
            yield service.setVaultContext(vaultId);
            service.setActionRef(constants_1.actionRefs.STACK_CREATE);
            service.setFunction(constants_1.functions.NODE_CREATE);
            const fileService = new file_1.FileService(this.wallet, this.api, service);
            const { file, resourceUri } = yield fileService.import(fileTxId);
            const version = new types_1.FileVersion({
                owner: yield this.wallet.getAddress(),
                createdAt: JSON.stringify(Date.now()),
                name: yield service.processWriteString(file.name),
                type: file.type,
                size: file.size,
                resourceUri: resourceUri,
            });
            const state = {
                name: yield service.processWriteString(file.name),
                versions: [version]
            };
            const { nodeId, transactionId, object } = yield service.nodeCreate(state, { parentId: options.parentId }, options.arweaveTags);
            return { stackId: nodeId, transactionId, object, uri: object.uri };
        });
    }
    /**
     * @param  {string} stackId
     * @param  {FileSource} file file source: web File object, file path, buffer or stream
     * @param  {FileUploadOptions} [options] progress hook, cancel hook, etc.
     * @returns Promise with corresponding transaction id
     */
    uploadRevision(stackId, file, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const service = new StackService(this.wallet, this.api);
            yield service.setVaultContextFromNodeId(stackId, this.objectType);
            service.setActionRef(constants_1.actionRefs.STACK_UPLOAD_REVISION);
            service.setFunction(constants_1.functions.NODE_UPDATE);
            const optionsFromVault = {
                storage: service.vault.cloud ? types_1.StorageType.S3 : types_1.StorageType.ARWEAVE
            };
            const uploadOptions = Object.assign(Object.assign({}, optionsFromVault), options);
            const fileService = new file_1.FileService(this.wallet, this.api, service);
            fileService.contentType = this.fileService.contentType;
            const fileLike = yield (0, file_1.createFileLike)(file, options);
            const fileUploadResult = yield fileService.create(fileLike, uploadOptions);
            const version = yield fileService.newVersion(fileLike, fileUploadResult);
            const state = {
                versions: [version]
            };
            const { transactionId, object } = yield service.nodeUpdate(state);
            return { transactionId, object, uri: object.uri };
        });
    }
    /**
     * Get stack version by index, return the latest version by default
     * @param  {string} stackId
     * @param  {number} [index] stack version index
     * @returns Promise with version name & data stream or buffer
     */
    getVersion(stackId, index, options = { responseType: 'arraybuffer' }) {
        return __awaiter(this, void 0, void 0, function* () {
            const service = new file_1.FileService(this.wallet, this.api);
            const stackProto = yield this.api.getNode(stackId, constants_1.objectType.STACK);
            const stack = new types_1.Stack(stackProto, stackProto.__keys__);
            yield service.setVaultContext(stack.vaultId);
            const version = stack.getVersion(index);
            if (!service.isPublic) {
                yield version.decrypt();
            }
            const data = yield service.download(version.getUri(types_1.StorageType.S3), { responseType: options.responseType, chunkSize: version.chunkSize || version.size });
            return Object.assign(Object.assign({}, version), { data });
        });
    }
    /**
     * Download stack version by index, return the latest version by default.
     * This method can be used for downloading the binary or previewing it in browser (use options.noSave).
     *
     * To download the file in browser / on server:
     *    akord.stack.download(stackId, index)
     *
     * To preview the file in browser:
     *    const url = await akord.stack.download(stackId, index, { skipSave: true })
     *    <video src={url} controls />
     *
     * @param  {string} stackId
     * @param  {number} index stack version index
     * @param  {object} options control download behavior
     * @returns Url pointing to the downloaded / previewable file
     */
    download(stackId, index = 0, options = {}) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let downloadPromise;
            switch ((0, platform_1.getPlatform)()) {
                case platform_1.Platform.BrowserNoWorker:
                    if (!this.isPublic) {
                        logger_1.Logger.warn('@akord/crypto: decryption worker is not registered, falling back to in memory decryption.\n' +
                            'See: https://github.com/Akord-com/akord-crypto#decryption-worker.');
                    }
                case platform_1.Platform.Server:
                    const { name, type, data } = yield this.getVersion(stackId, index, Object.assign(Object.assign({}, options), { responseType: 'stream' }));
                    const path = options.path ? `${options.path}/${name}` : name;
                    const contentType = type;
                    downloadPromise = this.saveFile(path, contentType, data, options.skipSave);
                    break;
                case platform_1.Platform.Browser:
                    const service = new StackService(this.wallet, this.api);
                    const stackProto = yield this.api.getNode(stackId, constants_1.objectType.STACK);
                    const stack = new types_1.Stack(stackProto, stackProto.__keys__);
                    const version = stack.getVersion(index);
                    const id = version.getUri(types_1.StorageType.S3);
                    const url = `${service.api.config.apiurl}/files/${id}`;
                    const proxyUrl = `${crypto_1.PROXY_DOWNLOAD_URL}/${id}`;
                    yield service.setVaultContext(stack.vaultId);
                    const workerMessage = {
                        type: 'init',
                        chunkSize: version.chunkSize,
                        size: version.size,
                        id: id,
                        url: url
                    };
                    if (!service.isPublic) {
                        yield version.decrypt();
                        const tags = yield this.api.getTransactionTags(id);
                        const encryptedKey = (_a = tags.find(tag => tag.name.toLowerCase() === constants_1.encryptionTags.ENCRYPTED_KEY.toLowerCase()
                            || tag.name.toLowerCase() === constants_1.encryptionTagsLegacy.ENCRYPTED_KEY.toLowerCase())) === null || _a === void 0 ? void 0 : _a.value;
                        const iv = (_b = tags.find(tag => tag.name === constants_1.encryptionTags.IV
                            || tag.name.toLowerCase() === constants_1.encryptionTagsLegacy.IV.toLowerCase())) === null || _b === void 0 ? void 0 : _b.value;
                        const key = yield service.dataEncrypter.decryptKey(encryptedKey);
                        workerMessage.key = key;
                        workerMessage.iv = iv;
                    }
                    workerMessage.name = version.name;
                    navigator.serviceWorker.controller.postMessage(workerMessage);
                    downloadPromise = new Promise((resolve, reject) => {
                        if (options.skipSave) {
                            resolve(proxyUrl);
                        }
                        else {
                            const interval = setInterval(() => {
                                const channel = new MessageChannel();
                                channel.port2.onmessage = (event) => {
                                    if (event.data.type === 'progress') {
                                        const progress = Math.min(100, Math.ceil(event.data.progress / version.size * 100));
                                        if (options.progressHook) {
                                            options.progressHook(progress);
                                        }
                                        if (event.data.progress === version.size) {
                                            clearInterval(interval);
                                            resolve(version.name);
                                        }
                                    }
                                    else {
                                        reject(event.data);
                                    }
                                };
                                navigator.serviceWorker.controller.postMessage({
                                    type: 'progress',
                                    id: id
                                }, [channel.port1]);
                            }, 100);
                        }
                    });
                    if (options.cancelHook) {
                        options.cancelHook.signal.onabort = () => {
                            navigator.serviceWorker.controller.postMessage({
                                type: 'cancel',
                                id: id
                            });
                        };
                    }
                    if (!options.skipSave) {
                        const anchor = document.createElement('a');
                        anchor.href = proxyUrl;
                        document.body.appendChild(anchor);
                        anchor.click();
                    }
                    break;
            }
            return downloadPromise;
        });
    }
    /**
     * Get stack file uri by index, return the latest file uri by default
     * @param  {string} stackId
     * @param  {StorageType} [type] storage type, default to arweave
     * @param  {number} [index] file version index, default to latest
     * @returns Promise with stack file uri
     */
    getUri(stackId, type = types_1.StorageType.ARWEAVE, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const stack = new types_1.Stack(yield this.api.getNode(stackId, constants_1.objectType.STACK), null);
            return stack.getUri(type, index);
        });
    }
    saveFile(path, type, stream, skipSave = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof window === 'undefined') {
                const fs = (yield Promise.resolve().then(() => __importStar(require("fs")))).default;
                const Readable = (yield Promise.resolve().then(() => __importStar(require("stream")))).Readable;
                return new Promise((resolve, reject) => Readable.from(stream).pipe(fs.createWriteStream(path))
                    .on('error', error => reject(error))
                    .on('finish', () => resolve(path)));
            }
            else {
                const buffer = yield stream_converter_1.StreamConverter.toArrayBuffer(stream);
                const blob = new Blob([buffer], { type: type });
                const url = window.URL.createObjectURL(blob);
                if (!skipSave) {
                    const a = document.createElement("a");
                    a.download = path;
                    a.href = url;
                    a.click();
                }
                return url;
            }
        });
    }
}
exports.StackService = StackService;
;
